module.exports = __webpack_public_path__ + "static/media/Mini Project-SY ETRX 21-22.f1c18bbe.pdf";